<template>
  <dialog class="modal" :open="computedValue" :class="{'modal-open': computedValue}">
    <div ref="modalBox" class="modal-box text-center">
      <button class="btn btn-sm btn-circle btn-ghost absolute right-2 top-2">
        <XMarkIcon class="h-6 w-6" aria-hidden="true" @click="computedValue = false"/>
      </button>
      <h3 class="text-lg font-semibold py-4">{{ __("Jaga") }}</h3>
      <a href="#" class="btn btn-outline btn-error w-full" @click.prevent="sendMail">
        <EnvelopeIcon class="w-4 h-4"/>
        {{ __("E-postiga") }}
      </a>
      <div class="divider">
        {{ __("või") }}
      </div>
      <a :href="url" class="btn btn-outline w-full" @click.prevent="copyUrl">
        <ClipboardIcon class="w-4 h-4"/>
        {{ copyValue || __("Kopeeri link") }}
      </a>
    </div>
  </dialog>
</template>

<script setup>
import {computed, ref} from "vue";
import {__} from "../utils.js";
import {onClickOutside, useClipboard} from "@vueuse/core";
import {ClipboardIcon, EnvelopeIcon, XMarkIcon} from "@heroicons/vue/24/solid";

const props = defineProps({
  showModal: Boolean,
  url: String,
  body: String
});
const modalBox = ref(null);
const source = ref("");
const copyValue = ref(null);
const close = () => {
  if (computedValue.value) {
    computedValue.value = false;
  }
};
onClickOutside(modalBox, close);
const {copy} = useClipboard({source, legacy: true});
const copyUrl = () => {
  copyValue.value = __("Kopeeritud!");
  copy(props.url);
  setTimeout(() => (copyValue.value = null), 1000);
};
const emit = defineEmits(["close"]);
const computedValue = computed({
  get() {
    return props.showModal;
  },
  set() {
    emit("close");
  }
});
const sendMail = () =>
    (document.location = "mailto: ?subject=" + props.body + props.url);
</script>
